import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { Money } from '../api/models';

@Pipe({
  name: 'money'
})
export class MoneyPipe implements PipeTransform {

  constructor(private currencyPipe:CurrencyPipe) {}

  transform(value: Money, display?: string|boolean, digitsInfo?: string ): string {
    if (value === null) {
      return this.currencyPipe.transform(null, null, display, digitsInfo);
    }
    return this.currencyPipe.transform(value.amount, value.currency, display, digitsInfo);
  }
}
